export default __webpack_public_path__ + "static/media/magikk_karma.e08ec3f4.svg";